import type { LucideIcon } from "lucide-react";
import {
  Code2,
  FileQuestion,
  ListChecks,
  Paperclip,
  PenLine,
  SlidersHorizontal,
  ToggleLeft,
} from "lucide-react";

import type { QuestionType } from "@/lib/api";

// SIMP-1 (2026-09-21): this ladder was written out five times — the library
// picker, the Questions list, Create, EditTest and the candidate's Review —
// and had already drifted three ways. Only three copies learned
// `file_upload -> Paperclip`, so a file-upload question wore the CODING icon
// in Create and EditTest, and only Review learned `likert`.
//
// One map, one fallback. The fallback is `Code2` because that is what all
// five ladders fell through to, so an unknown type renders exactly as it did.
export const QUESTION_TYPE_ICON: Readonly<Record<QuestionType, LucideIcon>> = {
  mcq: FileQuestion,
  mcq_multi: ListChecks,
  true_false: ToggleLeft,
  open_ended: PenLine,
  file_upload: Paperclip,
  likert: SlidersHorizontal,
  code: Code2,
};

// Takes a plain `string`, not `QuestionType`: the candidate Review card types
// its prop as `string` (it reads a snapshot blob, not the generated schema).
// The exhaustiveness that matters is on the map above — `Record<QuestionType,
// LucideIcon>` makes a new question type a compile error here rather than a
// silently wrong icon on five screens.
export function questionTypeIcon(type: string | null | undefined): LucideIcon {
  return (
    QUESTION_TYPE_ICON[(type ?? "") as QuestionType] ?? Code2
  );
}
